module.exports = __webpack_public_path__ + "static/media/BlueCard.4d1c3d25.svg";